import Query from '../../components/Report';

const query = ({ offset = 0 }) => new Query('categoryTopPages', { offset });

export default query;
